import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";
import "./i18n"; // Initialize i18n
import { logLoadFailure } from "./lib/logLoadFailure.ts";

function markAppLoaded(): void {
  document.body.classList.add("app-loaded");
  document.getElementById("app-fallback")?.remove();
}

try {
  createRoot(document.getElementById("root")!).render(
    <HelmetProvider>
      <App />
    </HelmetProvider>
  );
  markAppLoaded();
} catch (error) {
  console.error("[main] failed to mount app:", error);
  const detail = error instanceof Error ? error.message : String(error);
  logLoadFailure("react_mount_error", detail);
  window.__showAppLoadError?.("react_mount_error", detail);
}
